import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e5a6142"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-play-msg-box-wrap" }
const _hoisted_2 = { class: "game-play-msgbox-title-wrap" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar-line" }, null, -1))
const _hoisted_5 = { class: "msgbox-body-wrap" }
const _hoisted_6 = { class: "play-mode-list" }
const _hoisted_7 = { class: "play-mode-grid classic" }
const _hoisted_8 = { class: "grid-row cols-3 c1" }
const _hoisted_9 = { class: "grid-cell blue" }
const _hoisted_10 = { class: "cell-label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:11", -1))
const _hoisted_12 = { class: "grid-cell green" }
const _hoisted_13 = { class: "cell-label" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:8", -1))
const _hoisted_15 = { class: "grid-cell red" }
const _hoisted_16 = { class: "cell-label" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:11", -1))
const _hoisted_18 = { class: "grid-row cols-2 c2" }
const _hoisted_19 = { class: "grid-cell blue" }
const _hoisted_20 = { class: "cell-label" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:1", -1))
const _hoisted_22 = { class: "grid-cell red" }
const _hoisted_23 = { class: "cell-label" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:0.95", -1))
const _hoisted_25 = { class: "play-mode-meta" }
const _hoisted_26 = { class: "play-mode-label" }
const _hoisted_27 = { class: "play-mode-grid special" }
const _hoisted_28 = { class: "grid-row cols-4 c3" }
const _hoisted_29 = { class: "grid-cell blue" }
const _hoisted_30 = { class: "cell-label" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:25", -1))
const _hoisted_32 = { class: "grid-cell gold" }
const _hoisted_33 = { class: "cell-label" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:22", -1))
const _hoisted_35 = { class: "grid-cell gold" }
const _hoisted_36 = { class: "cell-label" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:50", -1))
const _hoisted_38 = { class: "grid-cell red" }
const _hoisted_39 = { class: "cell-label" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:40", -1))
const _hoisted_41 = { class: "grid-row cols-3 c4" }
const _hoisted_42 = { class: "grid-cell blue" }
const _hoisted_43 = { class: "cell-label" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:11", -1))
const _hoisted_45 = { class: "grid-cell green" }
const _hoisted_46 = { class: "cell-label" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:8", -1))
const _hoisted_48 = { class: "grid-cell red" }
const _hoisted_49 = { class: "cell-label" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:11", -1))
const _hoisted_51 = { class: "grid-row cols-3 c5" }
const _hoisted_52 = { class: "grid-cell blue" }
const _hoisted_53 = { class: "cell-label" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:1", -1))
const _hoisted_55 = { class: "grid-cell gold" }
const _hoisted_56 = { class: "cell-label" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:12", -1))
const _hoisted_58 = { class: "grid-cell red" }
const _hoisted_59 = { class: "cell-label" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-ratio" }, "1:0.95", -1))
const _hoisted_61 = { class: "play-mode-meta" }
const _hoisted_62 = { class: "play-mode-label" }
const _hoisted_63 = { class: "btn-group" }
const _hoisted_64 = {
  key: 0,
  class: "hint-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "game-play-msg-box-root",
    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('dialogs.gameplay.title')), 1),
        (_ctx.highlightSwitchPlayMode)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "close-btn",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
            }))
          : _createCommentVNode("", true),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["play-mode-item", { active: _ctx.selectedMode === 'classic' }]),
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectMode('classic')), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('game.playerpair')), 1),
                  _hoisted_11
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t('game.tie')), 1),
                  _hoisted_14
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('game.bankerpair')), 1),
                  _hoisted_17
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.t('game.player')), 1),
                  _hoisted_21
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.t('game.banker')), 1),
                  _hoisted_24
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", {
                class: _normalizeClass(["radio", {
                                selected: _ctx.selectedMode === 'classic'
                            }])
              }, null, 2),
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.t('dialogs.gameplay.classic')), 1)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["play-mode-item", { active: _ctx.selectedMode === 'special' }]),
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectMode('special')), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.t('bettype.bear8')), 1),
                  _hoisted_31
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.t('bettype.smalltiger')), 1),
                  _hoisted_34
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.t('bettype.bigtiger')), 1),
                  _hoisted_37
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.t('bettype.dragon7')), 1),
                  _hoisted_40
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.t('game.playerpair')), 1),
                  _hoisted_44
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.t('game.tie')), 1),
                  _hoisted_47
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.t('game.bankerpair')), 1),
                  _hoisted_50
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.t('game.player')), 1),
                  _hoisted_54
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.t('bettype.super6')), 1),
                  _hoisted_57
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.t('game.banker')), 1),
                  _hoisted_60
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", {
                class: _normalizeClass(["radio", {
                                selected: _ctx.selectedMode === 'special'
                            }])
              }, null, 2),
              _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.t('dialogs.gameplay.special')), 1)
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_63, [
          (_ctx.highlightSwitchPlayMode)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "btn-cancel",
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.t('common.cancel')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "btn-confirm",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.t('common.confirm')), 1)
        ]),
        (!_ctx.highlightSwitchPlayMode)
          ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(_ctx.t('dialogs.gameplay.hint')), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}